module.exports = __webpack_public_path__ + "img/discountStatus2.e67cc8c4.svg";